// src/components/FeaturedDishes.js
import React from 'react';
import { Link } from 'react-router-dom';
import dish1 from '../assets/dish4.jpg';
import dish2 from '../assets/dish19.jpg';
import dish3 from '../assets/dish12.jpg';

const DISHES = [
  {
    name: 'Deep-fried Soft Shell Crab With Chilli And Salt',
    description:
      'Crispy on the outside, tender on the inside — tossed with fragrant chilli, salt, and spices for a bold, flavour-packed bite.',
    image: dish1,
  },
  {
    name: 'Steamed Seabass With Chilli And Lime',
    description:
      'Fresh seabass gently steamed to perfection, bathed in a zesty chilli-lime broth that is tangy, spicy, and aromatic.',
    image: dish2,
  },
  {
    name: 'Pineapple Fried Rice',
    description:
      'Wok-fried rice tossed with sweet pineapple, prawns, and a warm hint of curry powder — served in true Thai style.',
    image: dish3,
  },
];

const FeaturedDishes = () => (
  <section className="featured">
    <div className="featured__header">
      <span className="featured__eyebrow">From Our Kitchen</span>
      <h2 className="featured__title">Featured Dishes</h2>
      <hr className="featured__divider" />
    </div>

    <div className="dishes-grid">
      {DISHES.map((dish) => (
        <article key={dish.name} className="dish-card">
          <img
            src={dish.image}
            alt={dish.name}
            className="dish-image"
            loading="lazy"
          />
          <div className="dish-details">
            <h3 className="dish-name">{dish.name}</h3>
            <p className="dish-description">{dish.description}</p>
          </div>
        </article>
      ))}
    </div>

    <div className="featured__cta">
      <Link to="/menu" className="btn btn-gold">View Full Menu</Link>
    </div>
  </section>
);

export default FeaturedDishes;
